const SecurityIdTypesEnum = Object.assign({
  LOAN: 'loan',
  TOKEN_SYMBOL: 'token_symbol',
  ISIN: 'isin',
});

Object.freeze(SecurityIdTypesEnum);

export default SecurityIdTypesEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/SecurityIdTypes.js